<template>
  <div>
    <h2 v-if="title">{{ title }}</h2>
    <p v-if="!events.length" class="empty-state">{{ emptyText }}</p>
    <ul v-else class="track-list">
      <EventCard
        v-for="event in events"
        :key="event.id"
        :event="event"
        :show-delete="showDelete"
        @select="$emit('select', $event)"
        @delete="$emit('delete', $event)"
      />
    </ul>
  </div>
</template>

<script setup>
import EventCard from './EventCard.vue'

defineProps({
  events: {
    type: Array,
    default: () => [],
  },
  title: {
    type: String,
    default: '',
  },
  emptyText: {
    type: String,
    default: 'Пока нет событий.',
  },
  showDelete: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['select', 'delete'])
</script>
